import styled from 'styled-components'

export const ConfigHeaderContainer = styled.div`
    width: 100%;
    height: 40px;
    background: ${({ theme }) => theme['gray-100']};
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    z-index: 10;

    .configheader-title {
        font-size: 16px;
        font-weight: 400;
        padding-left: 16px;
    }
`

export const FilterTimespanContainer = styled.div`
    height: 100%;
    display: flex;
    padding-right: 16px;
    gap: 8px;
    align-items: center;
`

export const GenerateButton = styled.button`
    text-transform: uppercase;
    height: 27px;
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme['blue-500']};
    display: flex;
    gap: 6px;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    color: ${({ theme }) => theme['gray-0']};
    padding: 0 8px;
    background-color: ${({ theme }) => theme['blue-500']};
`

export const CleanFiltersButton = styled.button`
    text-transform: uppercase;
    height: 27px;
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme['gray-500']};
    display: flex;
    gap: 6px;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    padding: 0 8px;
    background-color: transparent;
`
